import EmployeeDetail from "./EmployeeDetail";

export default EmployeeDetail;
